<template>
	<div class='search-c-wrap'>
		<div class="search-top">
			已为你按照“<span>{{keywords}}</span>”筛选，共筛选出<span>{{total}}</span>条数据
		</div>
		<div class="wrap-border">
			<ul class="search-list" v-if="list.length>0">
				<li class="flex flex-row-between" v-for="item in list" :key="item.id">
					<router-link class="company-list" target="_blank" :to="`/company?number=${item.number}`">
						<p v-html="item.matchTitle"></p>
					</router-link>
					<p>统一社会信用代码：{{item.number}}</p>
				</li>
			</ul>
			<empty v-else />
		</div>
		<div class="page-wrap">
			<el-pagination background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
		</div>
	</div>
</template>

<script>
import { searchEnterprise } from '@/api'

import empty from '@/components/empty'
export default {
	components: {
		empty
	},
	data() {
		return {
			keywords: undefined,
			type: undefined,
			list: [],
			total: 0,
			pageSize: 15
		}
	},
	created() { },
	mounted() {

	},
	methods: {
		getList(page = 1) {
			searchEnterprise({ type: this.type, keyword: this.keywords, current: page }).then(res => {
				const { total, records, size, current } = res;
				this.$set(this, 'pageSize', size);
				this.$set(this, 'total', total);
				this.$set(this, 'list', (records || []).map(item => Object.assign({}, item,
					{ matchTitle: item.name.replace(this.keywords, `<span style="color: #d01c0b;">${this.keywords}</span>`) })));
			})
		},
		handleCurrentChange(e) {
			this.getList(e)
		}
	},
	computed: {},
	watch: {
		$route: {
			handler(v) {
				const { query: { keywords, type } } = v;
				this.$set(this, 'keywords', keywords)
				this.$set(this, 'type', type)
				if (keywords && type) {
					this.getList()
				}
			},
			deep: true,
			immediate: true
		},
	},
}
</script>
<style lang='scss' scoped>
	.search-c-wrap {
		margin: 0 auto;
		padding: 20px 0;
		width: 1280px;
		& > .search-top {
			font-size: 16px;
			height: 38px;
			line-height: 38px;
			color: #212121;
			text-align: left;
			& > span {
				color: $red;
				font-weight: 600;
			}
		}
		& > .wrap-border {
			.search-list {
				& > li {
					&:nth-child(odd) {
						background-color: #f9fafc;
					}
					& > p,
					.company-list {
						width: 50%;
						text-align: center;
						line-height: 50px;
					}
					.company-list {
						p {
							width: 100%;
							span {
								color: #fff;
							}
						}
						span {
							color: $red;
						}
					}
				}
			}
		}
		& > .page-wrap {
			padding-top: 20px;
			text-align: right;
		}
	}
</style>